import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { CheckCircle2, Eye, History, Undo2 } from 'lucide-react';

const aed = (n) => Number(n || 0).toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const when = (s) => (s ? new Date(s).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' }) : '-');

const HistoryRow = ({ h, onView, onUndo, onDismiss }) => (
  <tr className="border-t border-slate-100" data-testid={`merged-row-${h.backup_id}`}>
    <td className="px-3 py-2 font-mono text-blue-700">{h.employee_unique_id}</td>
    <td className="px-3 py-2">{h.kept_name || '-'}</td>
    <td className="px-3 py-2">
      {h.undone
        ? <Badge variant="outline" className="bg-slate-100 text-slate-600">Undone</Badge>
        : <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">{h.action === 'merge' ? 'Merged' : 'Other deleted'}</Badge>}
    </td>
    <td className="px-3 py-2 text-slate-500">{when(h.created_at)}<div className="text-[10px]">{h.created_by}</div></td>
    <td className="px-3 py-2">{aed(h.total_loan_now)}</td>
    <td className="px-3 py-2">{aed(h.recovered_now)}</td>
    <td className="px-3 py-2 font-semibold" data-testid={`merged-outstanding-${h.backup_id}`}>{aed(h.outstanding_now)}</td>
    <td className="px-3 py-2">
      <div className="flex justify-end gap-1.5">
        <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" disabled={!h.kept_exists} onClick={() => onView(h)} data-testid={`merged-view-${h.backup_id}`}>
          <Eye className="w-3.5 h-3.5" />View loan account
        </Button>
        {!h.undone && (
          <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => onUndo(h)} data-testid={`merged-undo-${h.backup_id}`}>
            <Undo2 className="w-3.5 h-3.5" />Undo
          </Button>
        )}
        <Button size="sm" className="h-7 gap-1 text-xs bg-slate-800 text-white hover:bg-slate-900" onClick={() => onDismiss(h)} data-testid={`merged-dismiss-${h.backup_id}`}>
          <CheckCircle2 className="w-3.5 h-3.5" />Satisfied - remove
        </Button>
      </div>
    </td>
  </tr>
);

export const MergedHistory = ({ history, onView, onUndo, onDismiss }) => {
  const [showAll, setShowAll] = useState(false);
  if (!history?.length) return null;
  const shown = showAll ? history : history.slice(0, 5);
  return (
    <div className="rounded-lg border border-green-200 bg-white" data-testid="merged-history">
      <div className="flex items-center gap-2 border-b border-green-100 bg-green-50/60 px-4 py-2.5 font-semibold text-slate-800">
        <History className="w-4 h-4 text-green-700" />Merged history ({history.length})
        <span className="text-xs font-normal text-slate-500">Check each final loan account, then click "Satisfied - remove" to clear it from this list.</span>
      </div>
      <table className="w-full text-xs">
        <thead className="bg-slate-50 text-slate-500">
          <tr>{['Employee ID', 'Kept record', 'Status', 'When / by', 'Total loan now', 'Recovered now', 'Outstanding now', ''].map((c) => <th key={c} className="px-3 py-1.5 text-left font-medium">{c}</th>)}</tr>
        </thead>
        <tbody>
          {shown.map((h) => <HistoryRow key={h.backup_id} h={h} onView={onView} onUndo={onUndo} onDismiss={onDismiss} />)}
        </tbody>
      </table>
      {history.length > 5 && (
        <button type="button" className="w-full border-t border-slate-100 py-1.5 text-xs font-medium text-blue-700 hover:bg-slate-50" onClick={() => setShowAll((v) => !v)} data-testid="merged-history-toggle">
          {showAll ? 'Show latest 5 only' : `Show all ${history.length}`}
        </button>
      )}
    </div>
  );
};
